import PrimaryHeading from '../custom-ui/PrimaryHeading'

import CrmVsAi from './CrmVsAi'

const ReimaginingCrm = () => {
  return (
    <section className="overflow-hidden pb-6 pt-0 sm:py-24">
      <div className="custom_container container">
        <PrimaryHeading class="mb-3 w-full leading-[111%]">
          Reimagining CRM for&nbsp;
          <span className="relative font-semibold after:absolute after:bottom-0 after:left-1/2 after:h-[13px] after:w-full after:-translate-x-1/2 after:animate-pulse after:bg-aiUnderlineBlue after:bg-contain after:bg-no-repeat">
            the AI Age
          </span>
        </PrimaryHeading>
        <p className="mx-auto mb-12 max-w-[900px] text-center text-lg font-normal leading-125 tracking-[-0.72px] text-night-black sm:text-2xl">
          <span className="mb-5 inline-block">
            It&apos;s never been easier to capture, organize, analyze and share
            the conversations that grow your business.
          </span>
          <br />
          <span className="font-semibold">Day.ai </span> eliminates the
          complicated, manual interfaces of Legacy CRM, and keeps you connected
          to what your customers want.
        </p>
        <CrmVsAi />
      </div>
    </section>
  )
}

export default ReimaginingCrm
